import { render, staticRenderFns } from "./UnconfirmedVideoconsultationItem.vue?vue&type=template&id=984d2272"
import script from "./UnconfirmedVideoconsultationItem.vue?vue&type=script&lang=js"
export * from "./UnconfirmedVideoconsultationItem.vue?vue&type=script&lang=js"
import style0 from "./UnconfirmedVideoconsultationItem.vue?vue&type=style&index=0&id=984d2272&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports